<template>
  <apex-chart
    height="100%"
    width="100%"
    type="donut"
    :series="datatype.chart.seriesSUM"
    :key="datatype.chart.seriesSUM.length"
    :options="getOptions()"
  ></apex-chart>
</template>

<script>
export default {
  props: {
    datatype: null,
    colors: null,
  },
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {
    getOptions() {
      /** @type {ApexCharts.ApexOptions} */
      var chartOptions = {
        colors: this.colors ? this.colors : [this.Colors.IconColor, this.Colors.ActiveItemBackground2],
        chart: {
          width: "100%",
          type: "donut",
        },
        title: {
          text: this.datatype.chart.title,
          align: "left",
          style: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontWeight: "regular",
          },
        },
        theme: {
          mode: this.$vuetify.theme.global.name,
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            donut: {
              size: "58%",
            },
            dataLabels: {
              minAngleToShowLabel: 1,
            },
          },
        },
        fill: {
          type: "gradient",
        },
        xaxis: {
          type: "category",
        },
        labels: this.datatype.chart.categoriesSUM,
        dataLabels: {
          background: {
            enabled: true,
            foreColor: this.Colors.Background,
            opacity: 0,
          },
          enabled: true,
          formatter: this.datatype.chart.formatterX,
        },
        tooltip: {
          enabled: !this.hideTooltips,
          theme: this.$vuetify.theme.global.name,
          y: {
            formatter: this.datatype.chart.formatterY,
            title: {
              formatter: this.datatype.chart.formatterTooltip,
            },
          },
        },
        legend: {
          fontSize: 14,
          fontFamily: "Roboto",
          position: "left",
          horizontalAlign: "left",
          offsetY: this.isOnMobile ? 20 : 60,
          itemMargin: {
            vertical: 10,
          },
          //   height: 140,
          //   width: 180,
          //   offsetX: 80,
        },
        responsive: [
          {
            breakpoint: 200,
          },
        ],
      };
      return chartOptions;
    },
  },
};
</script>

<style scoped>
* /deep/ .apexcharts-legend-text {
  align-content: end;
  white-space: pre-wrap !important;
}
</style>